module.exports = __webpack_public_path__ + "static/media/视频截图_4.11dd867c.png";